// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-a162db94]{font-weight:500;text-align:center}.documents a[data-v-a162db94]{color:var(--t1);display:block;font-size:18px;padding:7px 0;-webkit-text-decoration:none;text-decoration:none}.documents a[data-v-a162db94]:not(:last-child){border-bottom:1px solid #ccc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
